import BaseParagraph from "./baseParagraph.js";
import useColors from "../customHooks/useColors.js";

const BaseHeading = (props) => {
  const {
    h1 = false,
    h3 = false,
    h4 = false,
    bold = false,
    italic = false,
    style = {}, //ide na base paragraph u naslovu
    translate = true,
    children = undefined,
    className = null
  } = props;
  ////////////////////////////////////CURRENT THEME
  const [currentColors] = useColors();

  ////////////////////////////////////VARIABLES
  let fontSize;
  if (h1) {
    fontSize = "32px";
  } else if (h3) {
    fontSize = "20px";
  } else if (h4) {
    fontSize = "18px";
  } else {
    fontSize = "24px";
  }

  ////////////////////////////////////STYLES
  const styles = {
    mainHeading: {
      fontSize: fontSize,
      color: currentColors.tertiary,
    },
  };


  return (
    <>
      <BaseParagraph
        style={{ ...styles.mainHeading, ...style }}
        bold={bold}
        italic={italic}
        translate = {translate}
        className = {className}
      >
        {children}
      </BaseParagraph>
    </>
  );
};

export default BaseHeading;
